import React from 'react';
import { multiFactor } from '@firebase/auth';
import { Navigate, Outlet } from 'react-router';

import { useAuth } from '../../hooks/useAuth';
import { getNextMFAFactorIdNeedingSetup } from '../../features/authentication';
import { NavigateWithRedirect } from '../NavigateWithRedirect';

export const VerifiedUserLayout = () => {
  const { userType, user, emailVerificationDetails, isAccountPending } = useAuth();

  const { isEmailVerified } = emailVerificationDetails;

  // If the user is not authenticated, redirect them to the login page
  if (!user) {
    return <NavigateWithRedirect to="/login" />;
  }

  if (!isEmailVerified) {
    return <NavigateWithRedirect to="/request-verification" />;
  }

  if (isEmailVerified && isAccountPending) {
    // If the user is verified and their account is pending, redirect them to the pending account page
    return <Navigate replace to="/pending-account" />;
  }

  const nextMFAFactorIdNeedingSetup = getNextMFAFactorIdNeedingSetup({ userType, multiFactorUser: multiFactor(user) });

  if (nextMFAFactorIdNeedingSetup) {
    return <Navigate replace to={`/mfa-setup/${nextMFAFactorIdNeedingSetup}`} state={{ isAutomatedRedirect: true }} />;
  }

  return <Outlet />;
};
